'use client';
import Image from 'next/image';
import Link from 'next/link';

const partners = [
  {
    name: "Super AI",
    src: "/images/superai.webp",
    width: 90,
    height: 40,
    link: "https://superai.com", // respective link
  },
  {
    name: "DDD",
    src: "/images/ddd.webp",
    width: 160,
    height: 240,
    link: "https://ddd.com",
  },
  {
    name: "Global AI Show",
    src: "/images/gais.webp",
    width: 170,
    height: 240,
    link: "https://www.globalaishow.com",
  },
  {
    name: "Global Blockchain Show",
    src: "/images/gbs.webp",
    width: 170,
    height: 240,
    link: "https://www.globalblockchainshow.com/",
  },
  {
    name: "Global Games Show",
    src: "/images/ggs.webp",
    width: 170,
    height: 240,
    link: "https://www.globalgamesshow.com",
  },
  {
    name: "rework",
    src: "/images/rework-logo.svg",
    width: 170,
    height: 240,
    link: "https://ny-ai-finance.re-work.co/",
  },
   {
    name: "Corinium",
    src: "/images/corinium-logo-new.webp",
    width: 170,
    height: 140,
    link: "https://cdaofs.coriniumintelligence.com/",
  },
  
];

const PartnersSection = () => {
  return (
    <section
      id="partners"
      className="w-full px-4 py-[40px] flex flex-col items-center justify-center bg-gradient-to-br from-[#fef6fa] to-[#f9f1f8]"
    >
      <div className="w-full max-w-[1270px]">
        {/* Section Title */}
        <h2 className="text-[24px] sm:text-[30px] lg:text-4xl font-extrabold leading-[28px] sm:leading-[34px] lg:leading-5xl text-center text-text-darkest mb-[30px]">
          Past Partners & Collaborators
        </h2>

        {/* Partner Logos Box */}
        <div className="w-full bg-white border-[2px] border-[#FA4B7F] rounded-[16px] p-6 sm:p-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 place-items-center">
            {partners.map((partner, index) => (
              <Link key={index} href={partner.link} target="_blank" rel="noopener noreferrer nofollow">
                <Image
                  src={partner.src}
                  alt={partner.name}
                  width={partner.width}
                  height={partner.height}
                  unoptimized
                  className="w-[120px] h-[80px] object-contain transition-transform duration-200 hover:scale-105"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
